
const InterestInfoSummary = ({ data, config: { dateFormat } }: any) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3">
    <div>
      <div className="grid grid-cols-3 gap-6">
        <div>
          <span className="block text-sm font-light text-gray-700">
            Customer Name
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.customer?.fullName || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Phone Number
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.customer?.phoneNumber || "N/A"}
          </div>
        </div>
        <div className="">
          <span className="block text-sm font-light text-gray-700">
            Digital Address
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.customer?.digitalAddress || "N/A"}
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default InterestInfoSummary;